import React, { createContext, useContext, useState, useEffect } from "react";

const CurrencyContext = createContext();
const defaultCurrency = { code: "EGY", flag: "eg" };

export const useCurrency = () => useContext(CurrencyContext);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    const stored = localStorage.getItem("currency");
    return stored ? JSON.parse(stored) : defaultCurrency;
  });

  useEffect(() => {
    localStorage.setItem("currency", JSON.stringify(currency));
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};
